import React from 'react';
import Panel from 'react-bootstrap/lib/Panel';

import Link from '../../../components/Link';

import Question from '../../../components/Help/Questions/Question';

class TrustAndSafetySection extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Panel>
          <Panel.Heading>Community Guidelines</Panel.Heading>
          <Panel.Body>
            <Question
              answer={
                <div>
                  <p>
                    At its core, Shadower is centered around community. We are a
                    community of learners and instructors seeking to share
                    knowledge in a more accessible, effective and affordable way
                    than traditional education. As a community, we value respect
                    and trust, without which we cannot grow. Respect both on and
                    off the platform is essential in becoming a member of the
                    shadowing community. Shadower is not a platform to harass,
                    disrespect, abuse, threaten or intimidate others, in real
                    life or on the site. By agreeing to our{' '}
                    <Link to="/policies/terms-of-service">
                      Terms of Service
                    </Link>{' '}
                    you agree to these policies regarding non-descrimination and
                    prohibited practices.
                  </p>
                </div>
              }
              question="Our community"
            />

            <Question
              answer={
                <div>
                  We take privacy and data protection very seriously. There are
                  certain types of information that we need to collect for the
                  platform to operate and other types we collect in order to
                  enhance user experience. Read more in our{' '}
                  <Link to="/policies/privacy-policy">Privacy Policy</Link>.
                </div>
              }
              question="Privacy and data protection"
            />

            <Question
              answer={
                <div>
                  Shadower monitors the site daily for fraud, misuse, abuse and
                  any conduct that violates our{' '}
                  <Link to="/policies/terms-of-service">Terms of Service</Link>,
                  but we also rely on our community to promote a safe learning
                  environment. If you believe a violation has occurred, please
                  contact us with a link of the content or profile in question.
                  Reporting a user does not guarantee that his or her account
                  with Shadower will be removed, only that it will be reviewed
                  by our team of moderators.
                  <br />
                  <br />
                  <div>Three-Strike System</div>
                  Shadower uses a three-strike system for policy violations and
                  may deactivate or terminate the accounts of shadowers and
                  experts who have repeatedly demonstrated a pattern of
                  exclusion and disrespect or whose conduct on the platform or
                  in person has failed to meet a certain standard of quality. If
                  our team of moderators determines that a violation has
                  occurred, a strike will be internally recorded to the user's
                  profile. After three strikes, a user will no longer be allowed
                  to transact on the platform (i.e. book a session or receive
                  payment from a booked session) for a full month, at which
                  point the strikes will be removed from the user's profile. If
                  the violations resulted from illegal or fraudulent activity,
                  the user's full account will be removed without strikes being
                  issued.
                </div>
              }
              question="Report a violation"
            />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>Safe Shadowing</Panel.Heading>
          <Panel.Body>
            <Question
              answer={
                <div>
                  While background checks may help prevent fraud, abuse and
                  misuse, they cannot guarantee safety in all circumstances.
                  Consequently, experts and shadowers should exercise judgement
                  and follow these{' '}
                  <Link to="/trust-and-safety/safety-tips">
                    sensible safety tips
                  </Link>
                  .
                </div>
              }
              question="Safety tips"
            />

            <Question
              answer={
                <div>
                  All users who transact on the platform will be subject to a
                  background check as permitted by applicable law, which
                  includes the national sex offender registry (NSOPW) and the
                  OFAC list for terrorist designations. We may also check public
                  state and county criminal records as well. Learn more about{' '}
                  <Link to="/trust-and-safety">trust and safety</Link>.
                </div>
              }
              question="How are shadowers and experts vetted?"
            />

            <Question
              answer={
                <div>
                  Sometimes, an expert may request that you contact them to
                  schedule a session, which is totally fine. However, after
                  agreeing on a time, the expert is required to create a session
                  that you can book. Please report any experts who fail to
                  follow this procedure.
                  <br />
                  <br />
                  As a shadower, having a record of the session will help
                  protect you in the case of a dispute with your expert. Without
                  a record of the transaction, we will be unable to assist in
                  any sort of refund, if needed. Failing to follow these
                  guidelines could result in a suspension from the platform.
                </div>
              }
              question="An expert told me to pay them off the platform."
            />

            <Question
              answer={
                <div>
                  If a criminal conviction is flagged during our background
                  checks, a member of our team will perform a case-by-case
                  review, looking into the totality of information available,
                  including the specifics of the conviction and how long ago it
                  took place. Certain serious felonies such as conviction of
                  murder, rape or terrorism or inclusion on a sex offender
                  registry will result in a permanent ban from the platform.
                  Less serious crimes like property damage or disorderly conduct
                  will result in an individualized assessment.
                </div>
              }
              question="What if I fail a background check?"
            />

            <Question
              answer={
                <div>
                  Users do not have access to your work address (or home address
                  if you work from home) until they book a session with you.
                  Everyone else simply sees a general area.
                </div>
              }
              question="Will my address be listed?"
            />

            <Question
              answer={
                <div>
                  Minors aged 13 - 17 are allowed to bring one parent or
                  guardian with them during the shadowing session free of
                  charge. Although the parent or guardian will not be
                  participating in the activities, experts are expected to
                  reasonably accommodate their addition to the session.
                </div>
              }
              question="Can I join my child as a guardian?"
            />

            <Question
              answer={
                <div>
                  When you book a session, you agree to our{' '}
                  <Link to="/policies/shadowing-waiver">Shadowing Waiver</Link>.
                </div>
              }
              question="Do I need to sign a waiver?"
            />
          </Panel.Body>
        </Panel>
      </React.Fragment>
    );
  }
}

export default TrustAndSafetySection;
